import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Consulta from './pages/Consulta';
import Comprobante from './pages/Comprobante';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Consulta/>}/>
        <Route path='/comprobante' element={<Comprobante/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
